import type { TacticResultBrowsingFilter } from '../../actions';
import type { GridElementPropertyAttentionStatusByCalculationType } from '../../evaluation/AttentionStatusRepository';
import { getLoadFlowDetailsGridElementsRequiringAttention } from '../../evaluation/loadFlow/attentionRequired';
import { getShortCircuitDetailsGridElementsRequiringAttention } from '../../evaluation/shortCircuit/attentionRequired';
import type {
  DomainGuid,
  TacticResultBrowsingFilterToCountMapping
} from '../../index';
import type { GridElementsDetailsByCalculationType } from '../gridElementsDetailsByCalculationType/GridElementsDetails';

export function getGridElementAttentionRequiringResultsCount(
  objectId: DomainGuid,
  gridElementsDetails: GridElementsDetailsByCalculationType,
  tacticResultBrowsingFilter: TacticResultBrowsingFilter,
  attentionStatuses: GridElementPropertyAttentionStatusByCalculationType
): number {
  const gridElementShortCircuitResultsCount =
    getShortCircuitDetailsGridElementsRequiringAttention(
      gridElementsDetails,
      attentionStatuses.shortCircuit
    ).filter(
      evaluatedGridElement => evaluatedGridElement.id === objectId
    ).length;

  const gridElementLoadFlowResultsCount =
    getLoadFlowDetailsGridElementsRequiringAttention(
      gridElementsDetails,
      attentionStatuses.loadFlow
    ).filter(
      evaluatedGridElement => evaluatedGridElement.id === objectId
    ).length;

  const tacticResultBrowsingFilterToCountMapping: TacticResultBrowsingFilterToCountMapping =
    {
      ALL:
        gridElementLoadFlowResultsCount + gridElementShortCircuitResultsCount,
      ALL_LOAD_FLOW: gridElementLoadFlowResultsCount,
      SELECTED_LOAD_FLOW: gridElementLoadFlowResultsCount,
      SHORT_CIRCUIT: gridElementShortCircuitResultsCount,
      NONE_AVAILABLE: 0
    };

  const count =
    tacticResultBrowsingFilterToCountMapping[tacticResultBrowsingFilter.type];

  return count;
}
